import { BaseControl } from './base-control';

import { RadioGroupControlInterface, RadioGroupOptionInterface } from '../components/radio-group/interfaces';

export class RadioGroupControl extends BaseControl<string | number | null> {
  public options: RadioGroupOptionInterface[];

  constructor(data: RadioGroupControlInterface) {
    super(data);

    this.options = data.options;
  }
}
